import React from 'react'

function WhatsAppContact() {
    const WhatsAppFunction = () => {
        const phoneNumber = '+923315555933'; // Ensure the + sign is present for international formatting
        const message = 'Hello, I need assistance regarding your services.';
        const encodedMessage = encodeURIComponent(message);
      
        // Detect if the user is on a mobile device
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      
        if (isMobile) {
          // Open WhatsApp app on mobile devices
          const whatsappMobileUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${encodedMessage}`;
          window.open(whatsappMobileUrl, '_self'); // Use '_self' for mobile compatibility
        } else {
          // Open WhatsApp Web on desktop
          const whatsappWebUrl = `https://web.whatsapp.com/send?phone=${phoneNumber.replace('+', '')}&text=${encodedMessage}`;
          window.open(whatsappWebUrl, '_blank');
        }
      };
      
  return (
    <div className='step1 w-[90%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[700px]  rounded-[4px] bg-[#303030] m-auto item-center justify-center   '>
            <h1 className="md:text-xl text-base text-white font-bold">Connect Instantly with Us</h1>
            <h1 className="md:text-sm text-sm  mt-4 text-[#bbbbbb] ">Scan the QR code below to quickly reach our help desk via your mobile. 
            We're here to assist you with any queries or concerns.</h1>
            <div className='w-full h-auto  justify-center flex mt-4 mb-4 '></div>
            <img src="/images/WhatsAppQrCode.png" alt="whats app code " className='w-[260px] h-auto m-auto' />
            <div className='flex w-full  h-auto   justify-center   '>
                <button className={` bg-red  py-2 px-6 xxs:text-sm   w-max rounded-[5px] text-white font-bold text-base mt-10`}

                    onClick={WhatsAppFunction}
                >Whats App</button>
            </div>
    </div>
  )
}

export default WhatsAppContact
